<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.clients.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyClientsNew'})"
        >
          Nov klient
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.clients.length">
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Naziv
                </th>
                <th class="text-left">
                  Naslov
                </th>
                <th class="text-left">
                  Davčna št.
                </th>
                <th class="text-left">
                  Končni potrošnik
                </th>
                <th class="text-left">
                  Davčni zavezanec
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="client in filteredClients"
                :key="client.id"
              >
                <td>{{ client.name }}</td>
                <td>{{ fullAddress(client) }}</td>
                <td>{{ client.tax_number }}</td>
                <td><ActiveIcon :value="client.client_type === 1" /></td>
                <td><ActiveIcon :value="client.tax_bound" /></td>
                <td>
                  <ButtonActionEdit @click="$router.push({name: 'MyCompanyClientsEdit', params: {id: client.id}})" />
                  <ButtonActionDelete @click="showDeleteClientModal = true; deleteClient = client" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega klienta uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje klienta"
      text="Ali ste prepričani, da želite izbrisati klienta? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteClientModal"
      @confirmed="remove(deleteClient)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import { objectToArray } from '@/utils/object'
import ActiveIcon from '@/components/ActiveIcon'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'

export default {
  components: {
    ConfirmDialog,
    ActiveIcon,
    ButtonActionEdit,
    ButtonActionDelete
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      showDeleteClientModal: false,
      deleteClient: null
    }
  },
  computed: {
    clients () {
      return objectToArray(this.$store.state.clients.items)
    },
    filteredClients () {
      return this.clients.filter(item => siIncludes({ haystack: item.name, needle: this.filter }) || (item.tax_number + '').includes(this.filter))
    }
  },
  methods: {
    ...mapActions('clients', ['loadItems', 'deleteItem']),
    fullAddress (client) {
      let address = client.address
      if (client.city) {
        if (client.post_code) {
          address += `, ${client.post_code} ${client.city}`
        } else {
          address += `, ${client.city}`
        }
      }
      return address
    },
    remove (item) {
      deleteItem(item, this)
    }
  },
  created () {
    loadItems(this)
  }
}
</script>
